import React from "react";
import { IEquipo } from "../models/interfaces/IEquipo";

import uno from "../assets/images/equipos/equipo1.svg";
import dos from "../assets/images/equipos/equipo2.svg";
import tres from "../assets/images/equipos/equipo3.svg";
import cuatro from "../assets/images/equipos/equipo4.svg";
import cinco from "../assets/images/equipos/equipo5.svg";
import seis from "../assets/images/equipos/equipo6.svg";

export const equipoData: IEquipo[] = [
  //Equipo 1
  {
    img: `${uno}`,
    texto: (
      <>
        <p>
          <strong>Lorem ipsum dolor sit amet</strong>
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </>
    ),
    alt: "equipo1",
    idEquipo: 1,
    width: "200px",
    height: "200px",
  },

  //Equipo 2
  {
    img: `${dos}`,
    texto: (
      <>
        <p>
          <strong>Lorem ipsum dolor sit amet</strong>
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </>
    ),
    alt: "equipo2",
    idEquipo: 2,
    width: "200px",
    height: "200px",
  },

  //Equipo 3
  {
    img: `${tres}`,
    texto: (
      <>
        <p>
          <strong>Lorem ipsum dolor sit amet</strong>
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </>
    ),
    alt: "equipo3",
    idEquipo: 2,
    width: "200px",
    height: "200px",
  },

  //Equipo 4
  {
    img: `${cuatro}`,
    texto: (
      <>
        <p>
          <strong>Lorem ipsum dolor sit amet</strong>
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </>
    ),
    alt: "equipo4",
    idEquipo: 4,
    width: "200px",
    height: "200px",
  },

  //Equipo 5
  {
    img: `${cinco}`,
    texto: (
      <>
        <p>
          <strong>Lorem ipsum dolor sit amet</strong>
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </>
    ),
    alt: "equipo5",
    idEquipo: 5,
    width: "200px",
    height: "200px",
  },

  //Equipo 6
  {
    img: `${seis}`,
    texto: (
      <>
        <p>
          <strong>Lorem ipsum dolor sit amet</strong>
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </>
    ),
    alt: "equipo6",
    idEquipo: 6,
    width: "200px",
    height: "200px",
  },
];
